// extracted by mini-css-extract-plugin
export default {"wrapper":"My-z","viewport":"Ny-z","container":"Oy-z","slide":"Py-z"};